<template>
	<section>
		<h1>Payment Information</h1>
		<div class="row">
			<CardList />
			<AddressList />
			<div class="col-12 mt-5">
				<div class="d-flex justify-content-between align-items-center">
					<h3 class="mb-0 font-20">Invoices</h3>
				</div>
				<InvoiceList
					v-if="!loading && invoices && invoices.length > 0"
					:invoices="invoices"
					@invoicepaid="getInvoices"
				/>
			</div>
			<NoData
				:collectionName="'invoices'"
				v-if="!loading && !errMsg && (!invoices || invoices.length === 0)"
			/>
			<ErrorAlert v-if="!loading && errMsg" :error="errMsg" />
			<Spinner v-if="loading" />
		</div>
	</section>
</template>

<script>
import AddressList from './AddressList';
import CardList from './CardList';
import InvoiceList from "../invoice/InvoiceList";
import InvoiceService from "../../services/invoice";
import NoData from "../shared/NoData";
import ErrorAlert from "../shared/ErrorAlert";
import Spinner from "../shared/Spinner";

export default {
	name: "PaymentInformation",
	components: {
		CardList,
		AddressList,
		InvoiceList,
		NoData,
		ErrorAlert,
		Spinner
	},
	data() {
		return {
			invoices: [],
			loading: false,
			errMsg: null,
		};
	},
	mounted() {
		this.getInvoices();
	},
	methods: {
		getInvoices() {
			this.loading = true;
			InvoiceService.instance()
				.getInvoices({ page: 0, size: 10 })
				.then((result) => {
					this.loading = false;
					this.errMsg = null;
					this.invoices = result.data.content;
				})
				.catch((err) => {
					this.loading = false;
					this.errMsg = err;
				});
		},
	},
};
</script>
